/**
 * Floating chat trigger — bottom-right on all pages except /cleo and /support.
 */
import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { useTheme } from '../lib/theme';
import CleoChat from './CleoChat';

const HIDDEN_ROUTES = ['/cleo', '/support'];

export default function CleoFloatingButton() {
  const location = useLocation();
  const { colors } = useTheme();
  const [open, setOpen] = useState(false);

  // Close panel on navigation.
  useEffect(() => { setOpen(false); }, [location.pathname]);

  if (HIDDEN_ROUTES.some((r) => location.pathname.startsWith(r))) return null;

  return (
    <>
      <button
        data-testid="cleo-floating-btn"
        onClick={() => setOpen(true)}
        aria-label="Ask Cleo"
        title="Ask Cleo"
        className="fixed bottom-6 right-6 w-[52px] h-[52px] rounded-full flex items-center justify-center z-40 transition-transform hover:scale-105"
        style={{
          backgroundColor: colors.surface,
          border: `2px solid ${colors.accent}`,
          boxShadow: `0 0 18px ${colors.accent}66, 0 4px 12px rgba(0,0,0,0.15)`,
          animation: 'cleoPulse 2.4s ease-out infinite',
        }}>
        <img src="/cleo-avatar.png" alt="Cleo" className="w-11 h-11 rounded-full" />
        <style>{`
          @keyframes cleoPulse {
            0%, 100% { box-shadow: 0 0 18px ${colors.accent}66, 0 4px 12px rgba(0,0,0,0.15); }
            50%      { box-shadow: 0 0 28px ${colors.accent}99, 0 4px 12px rgba(0,0,0,0.15); }
          }
        `}</style>
      </button>

      {open ? (
        <>
          {/* Backdrop */}
          <div
            data-testid="cleo-panel-backdrop"
            className="fixed inset-0 bg-black/40 z-40"
            onClick={() => setOpen(false)}
          />
          {/* Slide-in panel */}
          <aside
            data-testid="cleo-panel"
            className="fixed top-0 right-0 z-50 h-screen w-full sm:w-[420px] shadow-2xl"
            style={{ backgroundColor: colors.bg, animation: 'cleoSlideIn 220ms ease-out' }}>
            <CleoChat compact onClose={() => setOpen(false)} />
            <style>{`
              @keyframes cleoSlideIn {
                from { transform: translateX(24px); opacity: 0; }
                to   { transform: translateX(0);    opacity: 1; }
              }
            `}</style>
          </aside>
        </>
      ) : null}
    </>
  );
}
